import { atom } from "jotai";

export const subsedeAtom = atom([]);
//export const listacampoDependencia = atom([]);
export const dependenciaSubsede= atom();
//export const nameCampo= atom();

export const listaCampos=atom([]);
export const perfiles=atom([]);
export const sedes=atom([]);
export const secciones=atom([]);
export const tipoPlanillas=atom([]);
export const cargos=atom([]);
export const camposColaborador=atom([]);